/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { QueryRow, QueryRow$inboundSchema } from "./queryrow.js";
import { QuerySeries, QuerySeries$inboundSchema } from "./queryseries.js";

/**
 * Result of a generic analytics query: a grouped table and a matching per-group timeseries over the same data slice.
 */
export type QueryResult = {
  /**
   * Echoes the requested group_by dimension; empty when none was requested.
   */
  groupBy: string;
  /**
   * The timeseries bucket interval in seconds.
   */
  intervalSeconds: number;
  /**
   * Grouped totals over the full time range, ordered by sort_by descending.
   */
  table: Array<QueryRow>;
  /**
   * One series per group value (aligned with table rows), each gap-filled.
   */
  timeseries: Array<QuerySeries>;
};

/** @internal */
export const QueryResult$inboundSchema: z.ZodMiniType<QueryResult, unknown> = z
  .pipe(
    z.object({
      group_by: z.string(),
      interval_seconds: z.int(),
      table: z.array(QueryRow$inboundSchema),
      timeseries: z.array(QuerySeries$inboundSchema),
    }),
    z.transform((v) => {
      return remap$(v, {
        "group_by": "groupBy",
        "interval_seconds": "intervalSeconds",
      });
    }),
  );

export function queryResultFromJSON(
  jsonString: string,
): SafeParseResult<QueryResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => QueryResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'QueryResult' from JSON`,
  );
}
